import { Customer } from "src/api-service";
import { AppError } from "../../app-store-error.types";
import { DEFAULT_CUSTOMER_LIST_VISIBLE_COLUMNS } from "src/app/pages/home/page/customers/components/customers-table/customers.columns";

// **************************************************************************
// CUSTOMER STATE
// **************************************************************************
export interface CustomerState {
    customer: Customer | null;
    customers: Customer[];
    customerSearch: {
        results: Customer[];
        selected: Customer | undefined;
    };
    // List UI state
    loaded: boolean;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    sortProperty: string;
    sortAscending: boolean;
    searchFilter: string;
    visibleColumns: string[];
    // Loading
    loadingList: boolean;
    loadingDetail: boolean;
    creating: boolean;
    searchingCustomer: boolean;
    creatingDeliveryAddress: boolean;
    syncingFromAttio: boolean;
    // Error
    error: AppError | null;
}

export const initialCustomerState: CustomerState = {
    customer: null,
    customers: [],
    customerSearch: {
        results: [],
        selected: undefined,
    },
    // List UI state
    loaded: false,
    pageNumber: 1,
    pageSize: 50,
    totalCount: 0,
    sortProperty: "code",
    sortAscending: false,
    searchFilter: "",
    visibleColumns: DEFAULT_CUSTOMER_LIST_VISIBLE_COLUMNS,
    // Loading
    loadingList: false,
    loadingDetail: false,
    creating: false,
    searchingCustomer: false,
    creatingDeliveryAddress: false,
    syncingFromAttio: false,
    // Error
    error: null,
};
